const typographyFormActions = {
  true: 'Generate New Action',
  false: 'Edit Action',
  file: 'ATTACH FILES'
};

export default typographyFormActions;
